import { render, staticRenderFns } from "./TeachRoomExt3.vue?vue&type=template&id=1c7d9fb6&scoped=true&"
import script from "./TeachRoomExt3.vue?vue&type=script&lang=js&"
export * from "./TeachRoomExt3.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomExt3.vue?vue&type=style&index=0&id=1c7d9fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7d9fb6",
  null
  
)

export default component.exports